/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online violin plot maker. Paste one column per group to draw violin plots showing the full distribution (kernel density) and median of each group.`)
};

const es_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de violín en línea. Pega una columna por grupo para dibujar gráficos de violín que muestran la distribución completa (densidad de kernel) y la mediana de cada grupo.`)
};

const de_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Violin-Plot-Generator. Füge eine Spalte pro Gruppe ein, um Violin-Plots zu zeichnen, die die vollständige Verteilung (Kerndichte) und den Median jeder Gruppe zeigen.`)
};

const nl_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online vioolplot maker. Plak één kolom per groep om vioolplots te tekenen die de volledige verdeling (kerndichtheid) en mediaan van elke groep tonen.`)
};

const fr_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en violon gratuit en ligne. Collez une colonne par groupe pour tracer des graphiques en violon montrant la distribution complète (densité par noyau) et la médiane de chaque groupe.`)
};

const it_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a violino online. Incolla una colonna per gruppo per disegnare grafici a violino che mostrano l'intera distribuzione (densità kernel) e la mediana di ciascun gruppo.`)
};

const pt_br2_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráfico de violino online. Cole uma coluna por grupo para desenhar gráficos de violino mostrando a distribuição completa (densidade de kernel) e a mediana de cada grupo.`)
};

const pt_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de violino online. Cole uma coluna por grupo para desenhar gráficos de violino que mostram a distribuição completa (densidade kernel) e a mediana de cada grupo.`)
};

const ja_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンラインバイオリンプロット作成ツール。グループごとに1列を貼り付けるだけで、各グループの分布全体(カーネル密度)と中央値を示すバイオリンプロットを描画します。`)
};

const zh_violin_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线小提琴图生成器。每组粘贴一列数据，即可绘制显示每组完整分布（核密度）和中位数的小提琴图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_meta_description", locale)
	if (locale === "en") return en_violin_meta_description(inputs)
	if (locale === "es") return es_violin_meta_description(inputs)
	if (locale === "de") return de_violin_meta_description(inputs)
	if (locale === "nl") return nl_violin_meta_description(inputs)
	if (locale === "fr") return fr_violin_meta_description(inputs)
	if (locale === "it") return it_violin_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_violin_meta_description(inputs)
	if (locale === "pt") return pt_violin_meta_description(inputs)
	if (locale === "ja") return ja_violin_meta_description(inputs)
	return zh_violin_meta_description(inputs)
};